module.exports = __webpack_public_path__ + "media/images/lipo-30e0c2e2ddb363d678e6a632336b7373.svg";